const hash = window.location.hash
const firstLevelSelectedItemClass = '.first-level-selected__item'

jQuery(function($) {
    $(document).ready(() => {
        const dropdown = $('.fl-dropdown')
        const flDropdownTitle = $('.fl-dropdown__title')
        const firstLevel = $('.first-level')
        const firstLevelSelected = $('.first-level-selected')
        const nextLevel = $('.next-level')
        const activeClass = 'active'
        const doneBtn = $('.done-btn')
        const flBlockMobileContainer = $('.fl-block-mobile__container')
        const lastLevel = $('.fl-block-mobile__last-level')
        const nextStep = $('.next-step')
        const mobileLevel_2 = $('.level-2')
        const breadcrumbsMobile = $('.breadcrumbs')
        const anchorsFromCMS = $('.anchor')
        const lightBgWrapper = $('.light-bg-wrapper')
        const breadcrumbs = window.footballNavigation
        const hasAnchorsFromCMS = anchorsFromCMS.length > 0
        const secondIdxDataAttr = 'second-idx'
        const allPathToPage = checkBreadcrumbs(breadcrumbs)
        const hideDefaultAnchorsModule = () => $('.anchors').css('display', 'none')

        if (hasAnchorsFromCMS) {
            hideDefaultAnchorsModule();
        }

        if (hash) {
            setTimeout(() => {
                window.location.hash = "";
                window.location.hash = hash;
            }, 300);
        }

        let pathToRequestedPage = []

        if (allPathToPage.length) {
            if (isDesktop()) {
                $.each(allPathToPage, (i, item) => {
                    if (isFullPathToPage(item.path)) {
                        nextStep.before(`<a href="${item.path}" class="first-level-selected__item" data-first-idx="${i}">${item.text}</a>`)
                    } else {
                        nextStep.before(`<li class="first-level-selected__item" data-first-idx="${i}">${item.text}</li>`)
                    }
                })

                const hasMoreLevels = allPathToPage[allPathToPage.length - 1]?.submenu.length
                if (hasAnchorsFromCMS && allPathToPage.length > 1 && !hasMoreLevels) {
                    setAnchorsFromCms(anchorsFromCMS, nextLevel)
                } else if (hasMoreLevels) {
                    const lastIndex = allPathToPage.length - 1
                    setAnchorsFromCms(allPathToPage[lastIndex].submenu, nextLevel)
                }

                lightBgWrapper.css('display', 'block')

                const desktopAnchors = $('.next-level__item')
                toggleActiveClassInAnchors(desktopAnchors)

                firstLevel.hide()
                firstLevelSelected.css('display', 'flex')
                nextLevel.css('display', 'flex')
                $('.next-step__info').text('Select from bar below or scroll')

                const netxtLevelLength = nextLevel.children().length;

                if (netxtLevelLength > 5) {
                    nextLevel.slick({
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        accessibility: false,
                        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_light_arrowleft.svg" alt="Previous"/></button>',
                        nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_light_arrowright.svg" alt="Next"/></button>',
                    });
                }

                $('.fl-block-mobile__container').hide()
                $('.fl-block-mobile__last-level').show()

                const firstLevelSelectedItem = $(firstLevelSelectedItemClass)

                firstLevelSelectedItem.last().addClass('active')

                if (allPathToPage.length < 2) {
                    firstLevelSelectedItem.on('click', goByBreadcrumbs)
                }
            } else {
                const sliderFl = $('.fl-block-mobile__slider')

                // Initialize slick slider only on mobile
                sliderFl.not('.slick-initialized').slick({
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    accessibility: false,
                    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_light_arrowleft.svg" alt="Previous"/></button>',
                    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_light_arrowright.svg" alt="Next"/></button>',
                });

                flBlockMobileContainer.css('display', 'none')
                lastLevel.css('display', 'block')

                pathToRequestedPage = JSON.parse(window.localStorage.getItem('selectedBreadcrumbs'));

                pathToRequestedPage = pathToRequestedPage || allPathToPage;

                pathToRequestedPage = pathToRequestedPage.filter(({ text }) => text);

                pathToRequestedPage.forEach(({ path, text }) => {
                    if (path.endsWith('.php')) {
                        breadcrumbsMobile.append(`<a class="breadcrumbs__item" href="${path}">${text}</a>`);
                    } else {
                        breadcrumbsMobile.append(`<div class="breadcrumbs__item">${text}</div>`);
                    }
                });

                const links = document.querySelectorAll('a.breadcrumbs__item');

                links.forEach((link) => {
                    link.addEventListener('click', () => {
                        window.localStorage.removeItem('selectedBreadcrumbs');
                    });
                });

                const hasMoreLevels = allPathToPage[allPathToPage.length - 1]?.submenu.length

                if (hasAnchorsFromCMS && allPathToPage.length > 1 && !hasMoreLevels) {
                    setAnchorsFromCms(anchorsFromCMS, sliderFl)
                } else if (hasMoreLevels) {
                    const lastIndex = allPathToPage.length - 1
                    setAnchorsFromCms(allPathToPage[lastIndex].submenu, sliderFl)
                }

                sliderFl.slick('refresh')

                const mobileAnchors = $('.fl-block-mobile__slider-item')

                toggleActiveClassInAnchors(mobileAnchors)

                $('.select-topic-btn').css('display', 'none')
            }
        } else {
            initNavigation (breadcrumbs)

            window.localStorage.setItem('pathToStartPage', window.location.pathname)
        }

        const firstLevelElements = $('.first-level__item')

        firstLevelElements.on('click', function() {
            const element = $(this);

            lightBgWrapper.css('display', 'block');

            const selectedElement = `<li class="first-level-selected__item active">${element.text()}</li>`

            const firstIdx = element.data('first-idx')

            const secondLevelArray = getSubmenuByIdxElem(breadcrumbs, firstIdx).filter(({ text }) => text)

            $.each(secondLevelArray, (i, item) => setElemToSecondLevelNavigation(nextLevel, item, i, isFullPathToPage(item.path)))

            const secondLevelItems = $('[data-second-idx]')

            secondLevelItems.on('click', function() {
                const selectedElement = `<li class="first-level-selected__item active">${$(this).text()}</li>`

                const secondIdx = $(this).data(secondIdxDataAttr)

                const thirdLevelArray = getSubmenuByIdxElem(secondLevelArray, secondIdx).filter(({ text }) => text)
                nextLevel.empty()
                $(firstLevelSelectedItemClass).first().removeClass('active')

                $.each(thirdLevelArray, (i, item) => setElemToSecondLevelNavigation(nextLevel, item, i, true))

                nextStep.before(selectedElement)
            })

            nextStep.before(selectedElement)
        })

        $('.cancel-select').on('click', () => {
            const path = window.localStorage.getItem('pathToStartPage')?.replace(/"/g, '')

            window.location.assign(path || breadcrumbs[0].path)
        })

        // For mobile
        const secondLevelTitle = $('#secondTitle')
        const thirdLevelTitle = $('#thirdTitle')
        const fourthLevelTitle = $('#fourthTitle')
        const selectTopicBtn = $('.select-topic-btn')

        selectTopicBtn.on('click', () => $('.fl-block-mobile__container').slideToggle(300))

        $('.level-1 .fl-dropdown__item').on('click', initMobileSelect)

        flDropdownTitle.on('click', function () {
            const flDropdown = $(this).parent(dropdown)

            flDropdown.find($('.fl-dropdown__list')).slideToggle(300)

            $(this).toggleClass('open')
        })

        const flDropdownItem = $('.fl-dropdown__item')

        changeDropdownTitle(flDropdownItem, flDropdownTitle, dropdown, activeClass)

        doneBtn.on('click', () => {
            window.localStorage.setItem('selectedBreadcrumbs', JSON.stringify(pathToRequestedPage))
            window.location.assign(pathToRequestedPage[pathToRequestedPage.length - 1].path)
        })

        $('.change-btn').on('click', resetSelect)

        function resetSelect() {
            selectTopicBtn.css('display', 'inline-block')

            initNavigation(breadcrumbs)

            const flDropdownItem = $('.fl-dropdown__item')
            changeDropdownTitle(flDropdownItem, flDropdownTitle, dropdown, activeClass)

            $('.level-1 .fl-dropdown__item').on('click', initMobileSelect)

            flBlockMobileContainer.css('display', 'block')
            lastLevel.css('display', 'none')
        }

        function initMobileSelect() {
            const mobileLevel_3 = $('.level-3')
            const mobileLevel_4 = $('.level-4')

            secondLevelTitle.removeClass('disabled')

            doneBtn.removeClass('disabled')

            pathToRequestedPage = []

            const firstIdx = $(this).data('first-idx')
            const secondLevel = getSubmenuByIdxElem(breadcrumbs, firstIdx)

            pathToRequestedPage.push(breadcrumbs[firstIdx])

            mobileLevel_2.empty()
            mobileLevel_3.empty()
            mobileLevel_4.empty()

            resetDropdownTitle(secondLevelTitle, 'Select second step')

            addElementsToLevel(secondLevel, mobileLevel_2, 'second')

            const flDropdownItem = $('.fl-dropdown__item')
            changeDropdownTitle(flDropdownItem, flDropdownTitle, dropdown, activeClass)

            const secondLevelItems = $('[data-second-idx]')

            secondLevelItems.on('click', function() {
                const secondIdx = $(this).data(secondIdxDataAttr)

                const thirdLevelArray = getSubmenuByIdxElem(secondLevel, secondIdx)

                if (isFullPathToPage(secondLevel[secondIdx].path)) {
                    doneBtn.removeClass('disabled')
                }

                thirdLevelTitle.removeClass('disabled');

                if (pathToRequestedPage.length > 1) {
                    pathToRequestedPage = pathToRequestedPage.slice(0, 1);
                }

                pathToRequestedPage.push(secondLevel[secondIdx]);

                mobileLevel_3.empty()

                resetDropdownTitle(thirdLevelTitle, 'Select third step')

                addElementsToLevel(thirdLevelArray, mobileLevel_3, 'third')

                const flDropdownItem = $('.fl-dropdown__item')
                changeDropdownTitle(flDropdownItem, flDropdownTitle, dropdown, activeClass)

                const thirdLevelItems = $('[data-third-idx]');

                thirdLevelItems.on('click', function() {
                    const thirdIdx = $(this).data('third-idx');

                    const fourthLevelArray = getSubmenuByIdxElem(thirdLevelArray, thirdIdx);

                    if (isFullPathToPage(thirdLevelArray[thirdIdx].path)) {
                        doneBtn.removeClass('disabled')
                    }

                    fourthLevelTitle.removeClass('disabled');

                    pathToRequestedPage.push(thirdLevelArray[0]);

                    mobileLevel_4.empty();

                    resetDropdownTitle(fourthLevelTitle, 'Select fourth step');

                    addElementsToLevel(fourthLevelArray, mobileLevel_4, 'fourth');

                    const flDropdownItem = $('.fl-dropdown__item');

                    changeDropdownTitle(flDropdownItem, flDropdownTitle, dropdown, activeClass);

                    const fourthLevelItems = $('[data-fourth-idx]')

                    fourthLevelItems.on('click', function() {
                        doneBtn.removeClass('disabled')

                        const fourthIdx = $(this).data('fourth-idx')

                        pathToRequestedPage.push(fourthLevelArray[fourthIdx])
                    })
                })
            })
        }

        function goByBreadcrumbs() {
            const currentElement = $(this)
            const idx = currentElement.data('first-idx')

            const submenu = checkBreadcrumbs(breadcrumbs)[idx]?.submenu.filter(({ text }) => text)

            currentElement.siblings().removeClass('active')
            currentElement.nextAll().addClass('white')
            currentElement.prevAll().removeClass('white')
            currentElement.removeClass('white')
            currentElement.addClass('active')

            nextLevel.empty()

            $.each(submenu, (i, item) => {
                if (idx === 0) {
                    setElemToSecondLevelNavigation(nextLevel, item, i, isFullPathToPage(item.path))
                } else {
                    setElemToSecondLevelNavigation(nextLevel, item, i, true)
                }
            })

            if (idx === 0) {
                const firstIdx = currentElement.data('first-idx')
                const secondLevelArray = getSubmenuByIdxElem(breadcrumbs, firstIdx)
                const secondLevelItems = $('[data-second-idx]')

                secondLevelItems.on('click', function() {
                    const selectedElement = `<li class="first-level-selected__item active" data-first-idx=1>${$(this).text()}</li>`
                    const secondIdx = $(this).data(secondIdxDataAttr)
                    const thirdLevelArray = getSubmenuByIdxElem(secondLevelArray, secondIdx).filter(({ text }) => text)
                    nextLevel.empty()
                    $(firstLevelSelectedItemClass).first().removeClass('active')

                    $.each(thirdLevelArray, (i, item) => {
                        setElemToSecondLevelNavigation(nextLevel, item, i, true)
                    })

                    $('[data-first-idx=1]').replaceWith(selectedElement)
                })
            }
        }

        function initNavigation (navigation) {
            const notEmptyElements = navigation.filter(({ text }) => text)

            $.each(notEmptyElements, (i, item) => {
                setElemToFirstLevelNavigation(firstLevel, item, i, 'first-level__item', true)
                setElemToFirstLevelNavigation($('.level-1'), item, i, 'fl-dropdown__item')
            })
        }
    });
})

function getSubmenuByIdxElem(arr, idx) {
    return arr[idx]?.submenu
}

function checkBreadcrumbs(items = []) {
    const isActive = ({ active }) => active

    const firstLevelItems = items.find(isActive)

    const secondLevelItems = firstLevelItems?.submenu.find(isActive)
    const thirdLevelItems = secondLevelItems?.submenu.find(isActive)
    const fourthLevelItems = thirdLevelItems?.submenu.find(isActive)

    return [firstLevelItems, secondLevelItems, thirdLevelItems, fourthLevelItems].filter(Boolean)
}

function changeDropdownTitle(elements, title, dropdown, activeClass) {
    elements.on('click', function() {
        const currentItem = $(this)
        const currentTitle = $(this).parent().parent(dropdown).find(title)

        toggleActiveClassInList(currentItem)

        currentTitle.text($(currentItem).text())
        currentTitle.addClass(activeClass)
    })
}

function addElementsToLevel(elements, level, levelForAttr) {
    const notEmptyElements = elements.filter(({ text }) => text)

    $.each(notEmptyElements, (i, { text }) => {
        level.append(`<li class="fl-dropdown__item" data-${levelForAttr}-idx="${i}">${text}</li>`)
    })
}

function resetDropdownTitle(title, text) {
    title.text(text)
    title.removeClass('active')
}

function toggleActiveClassInList(elem) {
    elem.siblings().removeClass('active')
    elem.addClass('active')
}

function toggleActiveClassInAnchors(list) {
    list.on('click', function() {
        list.removeClass('active')
        $(this).addClass('active')
    })
}

function setAnchorsFromCms(anchors, anchorsLevel) {
    $.each(anchors, (_, item) => {
        const path = $(item).attr('href') || item.path
        const title = $(item).find('.title').text() || item.text

        if (!title) {
            return;
        }

        if (isDesktop()) {
            anchorsLevel.append(`<a href="${path}" class="next-level__item">${title}</a>`)
        } else {
            anchorsLevel.slick('slickAdd', `<div><div><a href="${path}" class="fl-block-mobile__slider-item">${title}</a></div></div>`)
        }
    })
}

function setElemToFirstLevelNavigation(level, { text, path }, index, classOfElem, isLink= false) {
    if(isLink){
        level.append(`<a href="${path}" class="${classOfElem} text-decoration-none" data-first-idx="${index}">${text}</a>`)
    } else {
        level.append(`<li class="${classOfElem}" data-first-idx="${index}">${text}</li>`)
    }

}

function setElemToSecondLevelNavigation(level, { text, path }, index, isLink = false) {
    if (isLink) {
        level.append(`<a href="${path}" class="next-level__item" data-third-idx="${index}">${text}</a>`)
    } else {
        level.append(`<li class="next-level__item" data-second-idx="${index}">${text}</li>`)
    }
}

function isFullPathToPage(path) {
    return path.endsWith('.php')
}

function isDesktop() {
    return $(window).width() > 992
}
